import { render, staticRenderFns } from "./cooperation.vue?vue&type=template&id=3bf4f763&scoped=true&"
import script from "./cooperation.vue?vue&type=script&lang=ts&"
export * from "./cooperation.vue?vue&type=script&lang=ts&"
import style0 from "./cooperation.vue?vue&type=style&index=0&id=3bf4f763&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf4f763",
  null
  
)

export default component.exports